const { render, useState } = wp.element;
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import * as Constants from "../.././constants";
//Import Designs
import {
    Typography,
    Grid2,
    Tabs,
    Tab,
    Dialog,
    DialogTitle as MuiDialogTitle,
    DialogContent as MuiDialogContent,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import LoginPanel from "./LoginPanel.jsx";
import Register from "./Register.jsx";
import ForgotForm from "./ForgotForm.jsx";

import {
    ForgotPassword,
    ResendVerificationEmail,
} from "../../actions/front_actions";
import ResendVerificationEmailForm from "./ResendVerificationEmailForm.jsx";

class Loginpopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: "",
            open: "",
            value: 0,
            forget_panel: 0,
            verification_panel: false,
        };
    }

    tabProps(index) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tab-${index}`,
        };
    }

    handleextClose = (event) => {
        this.closeForget();
    };

    handleChange = (event, newValue) => {
        var elemId = event.target.id;
        if (elemId == "") {
            elemId = event.target.parentNode.id;
        }
        var newValue1 = elemId.replace(/\D/g, "");
        this.setState({ value: newValue, tabindex: parseInt(newValue1) });
    };

    handleAccount = () => {
        this.setState({ value: 0 });
    };

    handleForget = () => {
        this.setState({ forget_panel: 1 });
    };

    closeForget = () => {
        this.setState({ forget_panel: 0 });
    };

    handleForgetEvent = (username) => {
        this.props.ForgotPassword(this.props.SITE_URL, username);
    };

    toggleVerificationEmail = (show) => {
        this.setState({ verification_panel: show });
    };

    handleVerificationEmail = (username) => {
        this.props.ResendVerificationEmail(this.props.SITE_URL, username);
    };

    render() {
        const { t } = this.props;
        const user_can_register = this.props.short.user_can_register;
        const allprops = this.props;
        const hide_account = allprops.settings.common.vote_hide_account;
        return (
            <>
                {this.state.forget_panel == 0 &&
                    this.state.verification_panel == false && (
                        <Dialog
                            onClose={() => {
                                this.props.handclose();
                            }}
                            aria-labelledby="customized-dialog-title"
                            open={this.props.showlog}
                        >
                            <MuiDialogTitle
                                component="div"
                                className="wpvc_login_popup_title"
                                onClose={() => {
                                    this.props.handclose();
                                }}
                            >
                                <Grid2 className="wpvc_login_panel" size={12}>
                                    <Tabs
                                        className="wpvc_login_panel_tabs"
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                    >
                                        <Tab
                                            className="wpvc_login_panel_tab"
                                            label={t("login")}
                                            {...this.tabProps(0)}
                                        />
                                        {user_can_register == 1 &&
                                            hide_account == "off" && (
                                                <Tab
                                                    className="wpvc_login_panel_tab"
                                                    label={t("create_account")}
                                                    {...this.tabProps(1)}
                                                />
                                            )}
                                    </Tabs>
                                    <IconButton
                                        className="wpvc_login_icon_button"
                                        aria-label="close"
                                        onClick={() => {
                                            this.props.handclose();
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </Grid2>
                            </MuiDialogTitle>
                            <MuiDialogContent
                                dividers
                                className="wpvc_login_popup_content"
                            >
                                <Grid2 container>
                                    <Grid2 size={12}>
                                        <form>
                                            {this.state.value == 0 && (
                                                <LoginPanel
                                                    constant={Constants}
                                                    {...allprops}
                                                    handleforgot={
                                                        this.handleForget
                                                    }
                                                    handleVerificationEmail={
                                                        this
                                                            .toggleVerificationEmail
                                                    }
                                                />
                                            )}
                                        </form>
                                        <form>
                                            {this.state.value == 1 && (
                                                <Register
                                                    {...allprops}
                                                    handleaccount={
                                                        this.handleAccount
                                                    }
                                                />
                                            )}
                                        </form>
                                    </Grid2>
                                </Grid2>
                            </MuiDialogContent>
                        </Dialog>
                    )}
                {this.state.forget_panel == 1 && (
                    <Dialog
                        onClose={() => {
                            this.handleextClose();
                        }}
                        aria-labelledby="customized-dialog-title"
                        open={this.props.showlog}
                    >
                        <MuiDialogTitle
                            component="div"
                            className="wpvc_login_popup_title"
                            onClose={() => {
                                this.handleextClose();
                            }}
                        >
                            <Grid2 className="wpvc_login_panel" size={12}>
                                <Typography
                                    className="wpvc_forget_title"
                                    variant="h6"
                                >
                                    {t("forgot_details")}
                                </Typography>
                                <IconButton
                                    className="wpvc_login_icon_button"
                                    aria-label="close"
                                    onClick={() => {
                                        this.handleextClose();
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Grid2>
                        </MuiDialogTitle>
                        <MuiDialogContent
                            dividers
                            className="wpvc_login_popup_content"
                        >
                            <Grid2 container>
                                <Grid2 size={12}>
                                    <form>
                                        <ForgotForm
                                            {...allprops}
                                            handleForgetEvent={
                                                this.handleForgetEvent
                                            }
                                            closeforgot={this.closeForget}
                                        />
                                    </form>
                                </Grid2>
                            </Grid2>
                        </MuiDialogContent>
                    </Dialog>
                )}
                {this.state.verification_panel && (
                    <Dialog
                        onClose={() => this.toggleVerificationEmail(false)}
                        aria-labelledby="customized-dialog-title"
                        open={this.props.showlog}
                    >
                        <MuiDialogTitle
                            component="div"
                            className="wpvc_login_popup_title"
                            onClose={() => {
                                this.toggleVerificationEmail(false);
                            }}
                        >
                            <Grid2 className="wpvc_login_panel" size={12}>
                                <Typography
                                    className="wpvc_forget_title"
                                    variant="h6"
                                >
                                    {t("resend_verification_email")}
                                </Typography>
                                <IconButton
                                    className="wpvc_login_icon_button"
                                    aria-label="close"
                                    onClick={() => {
                                        this.toggleVerificationEmail(false);
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Grid2>
                        </MuiDialogTitle>
                        <MuiDialogContent
                            dividers
                            className="wpvc_login_popup_content"
                        >
                            <Grid2 container>
                                <Grid2 size={12}>
                                    <form>
                                        <ResendVerificationEmailForm
                                            {...allprops}
                                            sendEmail={
                                                this.handleVerificationEmail
                                            }
                                            toggleVerificationEmail={
                                                this.toggleVerificationEmail
                                            }
                                        />
                                    </form>
                                </Grid2>
                            </Grid2>
                        </MuiDialogContent>
                    </Dialog>
                )}
            </>
        );
    }
}

const settingstate = (state) => {
    return { model: state.wpvcfrontdata };
};

export default connect(settingstate, {
    ForgotPassword,
    ResendVerificationEmail,
})(withTranslation("translations")(Loginpopup));
